import React from "react";
import "./Settings.css";

const Settings = () => {
  return (
    <div className="settings-container">
      <h1 className="settings-title">Settings</h1>
      {/* toggle button for data saver */}
      <div className="settings-section">
        <h2>Data Saver</h2>
        {/* on off button for data saver */}
        <button className="settings-button">
          <input type="checkbox" />
        </button>
      </div>
      <div className="settings-section">
        <h2>Shipping Policy</h2>
        <p>Ship within 2-3 days</p>
      </div>

      <div className="settings-section">
        <h2>Refund Policy</h2>
        <p>Within 7 days refund provided from refund request</p>
      </div>

      <div className="settings-section">
        <h2>Contact Us</h2>
        <p>Email: goldenmemory108@gmail.com</p>
        <p>Mobile No: 7509151875</p>
      </div>

      <div className="settings-section">
        <h2>Terms and Conditions</h2>
        <p>
          <a href="https://sites.google.com/view/goldenprivacypolicy/home">
            Terms and Conditions
          </a>
        </p>
      </div>

      <div className="settings-section">
        <h2>Privacy Policy</h2>
        <p>
          <a href="https://sites.google.com/view/goldenmemory108/home">
            Privacy Policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default Settings;
